import { RootState } from 'StoreTypes';

import { ChartPanelTabId } from 'views/chart/chart-panel-tabs/chartPanelTabsHelpers';

/** The currently active chart panel tab, or `null` if not yet initialized. */
export const selectActiveChartPanelTab = (state: RootState): ChartPanelTabId | null =>
  state.elationAI?.ui?.activeChartPanelTab ?? null;
